const SET_PROVIDER_CHECKOUT_URL = (state, purchase) => {
  const { checkout: { provider, url } } = purchase
  state.purchase[provider].checkout.url = url
}

export default {
  SET_PROVIDER_CHECKOUT_URL
}
